import type { QueueService } from '@telecom/shared/services/queue';
import type { TaskExecute } from '../types';

export interface TaskQueueService extends QueueService<TaskExecute> {}

export const TaskQueueService = Symbol.for('TaskQueueService');
